import {
  AfterViewInit,
  Component,
  HostListener,
  inject,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  viewChild
} from '@angular/core';
import { NgxsModule, Select, Store } from '@ngxs/store';
import {
  AuthState,
  BranchChange,
  loadMyBranches,
  Logout,
  NotificationClear,
  NotificationIncrease
} from '@beautyapp/auth';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NavigationItem } from '../common/navigation';
import {
  BookingService,
  Branch,
  CashierState,
  ChangeLanguage,
  CurrentCashier, EmployeeState,
  ENV_CONFIG,
  EnvironmentConfig,
  getEmployees,
  ResizeService,
  UserService
} from '@beautyapp/core';
import { takeUntil, tap } from 'rxjs/operators';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SwPush } from '@angular/service-worker';
import { DeviceDetectorService } from 'ngx-device-detector';
import { getToken, Messaging, onMessage } from '@angular/fire/messaging';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NotificationPanelComponent } from '../components/notification-panel/notification-panel.component';
import { NzNotificationComponent, NzNotificationService } from 'ng-zorro-antd/notification';
import { OnlineBookingModalComponent } from '@beautyapp/shared';
import { NzModalService } from 'ng-zorro-antd/modal';
import { environment } from 'ng-zorro-antd/core/environments';
import packageInfo from '../../../../../package.json';
import { ImportantInfoComponent } from '../components/important-info/important-info.component';
import { navigation } from './navigation';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { NzFlexDirective } from 'ng-zorro-antd/flex';

@Component({
    selector: 'beautyapp-main',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        NzGridModule,
        NzLayoutModule,
        NzButtonModule,
        NzDropDownModule,
        NzIconModule,
        NgxPermissionsModule,
        TranslateModule,
        NzSelectModule,
        FormsModule,
        NzSpaceModule,
        NzAlertModule,
        NgxsModule,
        NzBadgeModule,
        NzTooltipDirective,
        NzFlexDirective
    ]
})
export class AdminLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  public config: EnvironmentConfig = inject(ENV_CONFIG);
  private store: Store = inject(Store);
  private translateService: TranslateService = inject(TranslateService);
  private resizeSvc: ResizeService = inject(ResizeService);
  private bookingService: BookingService = inject(BookingService);
  private userService: UserService = inject(UserService);
  private deviceService: DeviceDetectorService = inject(DeviceDetectorService);
  private drawerService: NzDrawerService = inject(NzDrawerService);
  private swPush: SwPush = inject(SwPush);
  private notificationService: NzNotificationService = inject(NzNotificationService)
  private modalService: NzModalService = inject(NzModalService)

  version = packageInfo.version;


  notificationBtnTpl = viewChild<TemplateRef<{ $implicit: NzNotificationComponent }>>('notificationBtnTpl');


  selectedBranch$ = this.store.select(AuthState.getActiveBranch);
  branches$ = this.store.select(AuthState.myBranches);
  notificationCount$ = this.store.select(AuthState.getNotificationCount);

  authUser = this.store.selectSnapshot(AuthState.getProfile);

  isMobile = this.deviceService.isMobile();

  navigation: NavigationItem[] = navigation;
  selectedBranch!: Branch;
  isCollapsed = true;
  sub$: Subject<any> = new Subject<any>();

  size = 80;
  lang: any = 'ka';

  deviceInfo: any = null;

  cashiersCurrentPending$ = this.store.select(
    CashierState.currentCashierIsPending
  );

  bookings = [];

  // private readonly _messaging = inject(Messaging);
  private readonly _message = new BehaviorSubject<unknown | undefined | any>(undefined);

  message$ = this._message.asObservable();

  @HostListener('window:resize', [])
  private onResize() {
    this.detectScreenSize();
  }

  constructor() {
    this.lang = this.translateService.currentLang;
    // this.epicFunction();
  }

  ngOnInit(): void {
    this.store.dispatch(new loadMyBranches());
    this.store.dispatch(new getEmployees());
    this.selectedBranch$.pipe(takeUntil(this.sub$)).subscribe((res) => {
      if (res) {
        this.selectedBranch = res;
      }
    });
    this.store.dispatch(new CurrentCashier());
    // if(this.swUpdate.isEnabled) {
    //   this.swUpdate.available.subscribe(() => {
    //     if (confirm("New version available. Load New Version?")) {
    //       window.location.reload();
    //     }
    //   });
    // }

    this.bookingService.onlineBookings().subscribe((res) => {
      this.bookings = res;
    });

    // this.socketService.on('connect').subscribe((res) => {
    //   console.log('connected');
    // })

    // this._getDeviceToken();
    // this._onMessage();
    // this.listenForNotifications();
    this.listenForMessages();
    // this.epicFunction();
  }

  alertPlay() {
    const audio: HTMLAudioElement = new Audio('/assets/toast_sound.mp3');
    audio.play();
  }

  listenForMessages() {
    this.swPush.messages.subscribe((message: any) => {
      console.log('Received a push message', message);
      const {title, body, data} = message.notification
      // Here you can display the notification or process the payload
      this.store.dispatch(new NotificationIncrease());
      this.notificationService.create(
        'info',
        title,
        body,
        {
          nzDuration: 0, // This makes the notification stay indefinitely
          nzButton: this.notificationBtnTpl()
        }
      ).onClose.subscribe(() => {
        if (data.type === 'onlineBooking') {
          const modal = this.modalService.create({
            nzClosable: false,
            nzMaskClosable: false,
            nzTitle: this.translateService.instant('calendar.planVisit'),
            nzContent: OnlineBookingModalComponent,
            nzWidth: '1100px',
            nzStyle: { top: '0px' },
            nzBodyStyle: { padding: '0' },
            nzData: {
              id: data.id
            }
          });
        }
      })
      this.alertPlay();
    });
  }

  listenForNotifications(): void {
    const channel = new BroadcastChannel('notification_channel');
    channel.onmessage = (event) => {
      if (event.data.type === 'INCREMENT_NOTIFICATION_COUNT') {
        this.store.dispatch(new NotificationIncrease());

        this.alertPlay();
      }
    };
  }

  // private _getDeviceToken(): void {
  //   getToken(this._messaging, { vapidKey: this.config.vapidKey })
  //     .then((token: any) => {
  //       console.log(token);
  //       // save the token in the server, or do whathever you want
  //
  //       this.userService.pushFirebaseToken({
  //         token
  //       })
  //         .pipe(
  //           takeUntil(this.sub$)
  //         )
  //         .subscribe();
  //     })
  //     .catch((error: any) => console.log('Token error', error));
  // }
  //
  // private _onMessage(): void {
  //   onMessage(this._messaging, {
  //     next: () => {
  //       this.store.dispatch(new NotificationIncrease());
  //       this.alertPlay();
  //     },
  //     error: (error: any) => console.log('Message error', error),
  //     complete: () => console.log('Done listening to messages')
  //   });
  //
  // }


  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    if (this.isMobile) {
      // this.size = 0;
      // this.isCollapsed = true;
    }
  }

  ngAfterViewInit() {
    this.detectScreenSize();
  }

  private detectScreenSize() {
    this.resizeSvc.init();
    this.resizeSvc.mediaBreakpoint$.pipe(
      tap((r) => {
        this.size = r;
        if (r === 0) {
          this.isCollapsed = true;
        }
      })
    );
  }

  logout() {
    this.store.dispatch(new Logout());
  }

  setBranch(branch: any) {
    this.selectedBranch = branch;
    this.store.dispatch(new BranchChange(branch));
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }

  langChange(lang: 'en' | 'ru' | 'ka') {
    this.store
      .dispatch(new ChangeLanguage(lang))
      .pipe()
      .subscribe(() => {
        window.location.reload();
      });
  }

  versionUpdate() {
    window.location.reload();
  }

  openNotification() {
    this.drawerService.create({
      nzContent: NotificationPanelComponent,
      nzPlacement: 'right',
      nzWidth: 700
    });

    this.store.dispatch(new NotificationClear());
  }

  openImportantInfo() {
    this.modalService.create({
      nzContent: ImportantInfoComponent,
      nzFooter: null,
      nzWidth: '90%',
    });
  }
}
